import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { search_icon } from "../../assets";
import { fetchStoreOrders } from "../../Redux/Action/orderAction";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import Table from "../Tables/TableOrder";
import LoadingSpinner from "../CustomWidgets/Laoding";
import { CustomerForm } from "./CustomerForm";
import { detectWebDeviceType, isTablet } from "../../utils";
import { Button, Select } from "antd";
import CreditTableComponent from "./CreditTableComponent";
import AllCustomerTableComponent from "./AllCustomerTableComponent";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import { TextAlignCenter } from "lucide-react";
import Edit from "../../assets/edit.png";
import { RiArrowUpWideFill } from "react-icons/ri";
import AddCustomerModal from "./AddCustomerModal";
import { toast } from "react-toastify";
import { buttonClasses } from "@mui/material";
import axios from "axios";



export function Modal({ isOpen, onClose, children, title }) {


  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // cleanup
    };
  }, [isOpen]);

  if (!isOpen) return null;
  const deviceType = detectWebDeviceType();


  return (
    <div
      className={
        deviceType === "pc"
          ? "fixed inset-0 bg-black bg-opacity-50 backdrop-blur flex items-center justify-center p-4 z-50"
          : ""
      }
      style={
        deviceType === "tablet"
          ? {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }
          : {}
      }
    >
      <div
        className={`bg-white rounded-2xl ${deviceType === "tablet" ? "w-[55%] fixed left-16 " : "w-[80%]"
          }`}
      >
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-2xl font-semibold">{title}</h2>
          <button type="button" onClick={onClose} className="bg-transparent">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export function OrderSearchBar({
  fetchPosCreditData,
  searchTerm,
  setSearchTerm,
  setPagination,
  isAllCustomers
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const ref = useRef(null);


  const handleSearchChange = (term) => {
    if (term.length >= 3 || term === "") {
      if (isAllCustomers) {
        fetchPosCreditData(term, 1); // fetchAllCustomersData(search, page)
      } else {
        fetchPosCreditData(term, "", 1); // fetchPosCreditData(search, type, page)
      }
    }
  };


  const debouncedSearch = useMemo(() => debounce(handleSearchChange, 300), []);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setPagination((prev) => ({ ...prev, current: 1 }));
    debouncedSearch(term);
  };

  useEffect(() => {
    ref.current.focus();
  }, [searchTerm]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "x") {
        ref.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [ref]);

  return (
    <div className={`relative flex ${isRtl ? "me-8" : "ms-8"} me-8 w-[100%]`}>
      {isRtl ? (
        <span className="absolute inset-y-0 right-0 flex items-center pr-3">
          <img src={search_icon} alt="customers_search_icon" />
        </span>
      ) : (
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <img src={search_icon} alt="customers_search_icon" />
        </span>
      )}
      <input
        type="text"
        ref={ref}
        placeholder={t("Search Customer Name / Phone No.")}
        className="border p-3 ps-10 rounded w-full focus:outline-none rounded-[6px]"
        value={searchTerm} // Controlled input
        onChange={handleInputChange}
      />
    </div>
  );
}

function AllCustomersButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation()
  const isRtl = i18n.dir() === "rtl";

  const buttonClasses = `flex cursor-pointer  ${isRtl ? "ms-0" : "ms-6"
    } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
      "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
    }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("All Customers")}</div>
    </div>
  );
}
function CreditCustomersButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation()
  const isRtl = i18n.dir() === "rtl";

  const buttonClasses = `flex cursor-pointer  ${isRtl ? "ms-0" : "ms-2"
    } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
      "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
    }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ">{t("Credit Customers")}</div>
    </div>
  );
}

function Credit_Table() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);
  const [selectedButton, setSelectedButton] = useState("allCustomers")
  // const [pagination, setPagination] = useState(0);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
  });
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [editData, setEditData] = useState(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState(-1);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false); // Define loading state
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [paymentType, setPaymentType] = useState(""); // default to "All" => empty string
  const [allCustomersData, setAllCustomersData] = useState([])
  const { user } = useSelector((state) => state?.login);
  const [openAddCustomerModal, setOpenAddCustomerModal] = useState(false)
  const store_id = user?.result?.company_id;
  console.log(store_id)
  const [selectedPaymentType, setSelectedPaymentType] = useState("")


  const lang = i18n.language;

  const isCreditAmountZero = selectedOrderDetails?.credit_amount === 0;

  useEffect(() => {
    fetchPosCreditData();
  }, []);

  useEffect(() => {
    fetchAllCustomersData()
  }, [])



  const fetchPosCreditData = async (
    searchTerm = "",
    type = paymentType,
    page = 1,
    pageSize = pagination.pageSize
  ) => {
    const offset = (page - 1) * pageSize;
    const limit = pageSize;

    const payload = {
      search: searchTerm,
      ...(type && { type }),
      offset,
      limit,
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_POS_CREDIT_LIST, payload);

      if (response?.data?.result[0]?.status_code === 200) {
        setFilteredData(response?.data?.result[0]?.response || []);
      }
    } catch (error) {
      console.error("Error fetching Pos Credit data:", error);
    } finally {
      setLoading(false);
    }
  };
  const formatAddress = (address, t) => {
    if (!address) return "";

    const parts = [];

    if (address.add_field_1) {
      parts.push(
        `${address.name === "Villa"
          ? t("Villa No.-")
          : address.name === "Apartment"
            ? t("Building-")
            : address.name === "Office"
              ? t("Company-")
              : ""
        } ${address.add_field_1}`
      );
    }

    if (address.add_field_2) {
      parts.push(
        `${address.name === "Villa"
          ? t("Group No.-")
          : address.name === "Apartment"
            ? t("Apartment No.-")
            : address.name === "Office"
              ? t("Floor-")
              : ""
        } ${address.add_field_2}`
      );
    }

    if (address.add_field_3) {
      parts.push(
        `${address.name === "Villa"
          ? t("Street-")
          : address.name === "Apartment"
            ? t("Floor-")
            : address.name === "Office"
              ? t("Building-")
              : ""
        } ${address.add_field_3}`
      );
    }

    if (address.add_field_4) {
      parts.push(address.add_field_4);
    }

    return parts.join(", ");
  };



  const fetchAllCustomersData = async (searchTerm = "", page = 1, pageSize = pagination.pageSize) => {
    const offset = (page - 1) * pageSize;
    const limit = pageSize;

    const payload = {
      search: searchTerm,
      store_id,
      offset,
      limit
    }
    try {

      console.log("entered fetch all customers ")
      setLoading(true);
      const response = await axiosInstance.post(URLS.GET_ALL_CUSTOMERS, payload);
      if (response?.data?.result?.status_code === 200) {
        const rawCustomers = response?.data?.result?.customer_list;

        const formattedCustomers = rawCustomers.map((customer) => {


          return {
            ...customer,
            customer_name: customer.name,
            mobile_no: customer.phone,
            address: formatAddress(customer.addresses[0], t),
          };
        });

        setAllCustomersData(formattedCustomers);
      }
    } catch (error) {

      console.error("Error fetching all customers:", error);
    } finally {

      setLoading(false);
    }
  };


 const handleTablePageChange = (page) => {
  setPagination((prev) => ({ ...prev, current: page }));

  if (selectedButton === "allCustomers") {
    fetchAllCustomersData(searchTerm, page, pagination.pageSize); // 👈
  } else {
    fetchPosCreditData(searchTerm, paymentType, page, pagination.pageSize);
  }
};

  const handleRowClick = async (order) => {
    setSelectedOrderDetails(order); // Set the selected order details here
    setIsModalOpen(true);
  };

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: t("Customer Name"),
        accessor: "customer_name",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Phone No."),
        accessor: "mobile_no",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Address"),
        accessor: "address",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Credit Amount"),
        accessor: "credit_amount",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">
            {"EGP"} {value}
          </div>
        ),
        sortType: "alphanumeric",
      },
      {
        Header: t("Status"),
        accessor: "status",
        width: "10%",
        Cell: ({ row }) => {
          const creditAmount = row.original?.credit_amount;

          const isUnpaid = creditAmount > 0;
          const statusLabel = isUnpaid ? t("Unpaid") : t("Paid");

          const bgColor = isUnpaid ? "bg-[#F42020] text-white" : "bg-[#7EC242] text-white";
          const widthClass = isUnpaid ? "w-24" : "w-24";

          return (
            <div className="text-center">
              <span
                className={`flex justify-center font-semibold text-lg rounded-xl ${bgColor} ${widthClass}`}
                style={{
                  padding: "0.4rem 0.8rem",
                }}
              >
                {statusLabel}
              </span>
            </div>
          );
        },
      },
    ];

    return baseColumns;
  }, [user?.currency]);

  const AllCustomerColumns = useMemo(() => {
    const baseColumns = [
      {
        Header: t("Customer Name"),
        accessor: "customer_name",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Phone No."),
        accessor: "mobile_no",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Address"),
        accessor: "address",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Credit Amount"),
        accessor: "credit_amount",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">
            {"EGP"} {value}
          </div>
        ),
        sortType: "alphanumeric",
      },
      {
        Header: t("Status"),
        accessor: "status",
        width: "10%",
        Cell: ({ row }) => {
          const creditAmount = row.original?.credit_amount;

          const isUnpaid = creditAmount > 0;
          const statusLabel = isUnpaid ? t("Unpaid") : t("Paid");

          const bgColor = isUnpaid ? "bg-[#F42020] text-white" : "bg-[#7EC242] text-white";
          const widthClass = isUnpaid ? "w-24" : "w-24";

          return (
            <div className="text-center">
              <span
                className={`flex justify-center font-semibold text-lg rounded-xl ${bgColor} ${widthClass}`}
                style={{
                  padding: "0.4rem 0.8rem",
                }}
              >
                {statusLabel}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("History"),
        accessor: "pos_credit_id",
        Cell: ({ row }) => { // Destructure row directly here
          return (
            <div className="text-center">
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevents double-triggering the row click
                  handleRowClick(row.original); // <--- CHANGE THIS from pos_credit_id to row.original
                }}
                className="font-semibold w-45 h-15 text-md border border-black p-2 rounded-lg bg-white text-primaryBlue flex justify-center items-center gap-2 me-3"
              >
                {t("Payment History")}
              </button>
            </div>
          );
        }
      },

      {
        Header: t("Actions"),
        accessor: "actions",
        disableSortBy: true,
        width: "70px",
        Cell: ({ row }) => (
          <div className="flex gap-2 justify-start">
            <img
              src={Edit}
              className="cursor-pointer h-6 w-6"
              alt="Edit"
              onClick={(e) => {
                e.stopPropagation();
                setEditData(row.original);        // ✅ set the row data
                setOpenAddCustomerModal(true);
              }}
            />
          </div>
        ),
      },
    ];

    return baseColumns;
  }, [user?.currency]);

  const handleSubmit = () => {
    fetchPosCreditData();
    fetchAllCustomersData()
    setIsModalOpen(false);
  };

  let EKey = localStorage.getItem("eKeyPressed");

  const CreateCustomer = async (data) => {
    const payload = {
      "store_id": company_id,
      "user_id": user_id,
      "phone": data?.mobile,
      "name": data?.userName,
      "email": "",
      "address_type_id": data?.address_type_id,
      "add_field_1": data?.add_field_1,
      "add_field_2": data?.add_field_2,
      "add_field_3": data?.add_field_3,
      "add_field_4": data?.add_field_4,
      "credit_amount": data?.credit_amount,
      "credit_as_on_date": data?.credit_as_on_date,
    };

    try {
      const res1 = await axiosInstance.post(URLS.ADD_CUSTOMER, payload);
      if (res1?.data?.result?.status_code === 200) {  // ✅ correct path

        toast.success(t(res1?.data?.result?.status));  // ✅ fixed
        setOpenAddCustomerModal(false)
        fetchAllCustomersData()
      } else {
        toast.error(t(res1?.data?.result?.status));    // ✅ fixed
      }
    } catch (error) {
      console.error("Error fetching Credit History data:", error);
    } finally {
    }
  }

  const UpdateCustomer = async (data) => {
    const payload = {
      "store_id": company_id,
      "user_id": user_id,
      "phone": data?.mobile,
      "name": data?.userName,
      "customer_id": data?.customer_id,
      "email": "",
      "address_type_id": data?.address_type_id,
      "add_field_1": data?.add_field_1,
      "add_field_2": data?.add_field_2,
      "add_field_3": data?.add_field_3,
      "add_field_4": data?.add_field_4,
      "credit_amount": data?.credit_amount,
      "credit_as_on_date": data?.credit_as_on_date,
    };

    try {
      const res1 = await axiosInstance.post(URLS.UPDATE_CUSTOMER, payload);
      if (res1?.data?.result?.status_code === 200) {  // ✅ correct path
        toast.success(t(res1?.data?.result?.status));  // ✅ fixed
        setOpenAddCustomerModal(false)
        await fetchAllCustomersData()
      } else {
        toast.error(t(res1?.data?.result?.status));    // ✅ fixed
      }
    } catch (error) {
      console.error("Error fetching Credit History data:", error);
    } finally {
    }
  }


  const handleKeyDown = useCallback(
    (e) => {
      if (EKey === "true") {
        return;
      }
      if (e.shiftKey && e.key === "e") {
        setSelectedOrderIndex(null);
        return;
      }

      const normalizedKey = e.key.toLowerCase();

      if (normalizedKey === "arrowup" && !isModalOpen) {
        e.preventDefault();
        if (selectedOrderIndex > 0) {
          setSelectedOrderIndex(selectedOrderIndex - 1);
        }
      } else if (normalizedKey === "arrowdown" && !isModalOpen) {
        e.preventDefault();
        if (selectedOrderIndex < filteredData.length - 1) {
          setSelectedOrderIndex(selectedOrderIndex + 1);
        }
      } else if (
        normalizedKey === "enter" &&
        selectedOrderIndex >= 0 &&
        !isModalOpen
      ) {
        e.preventDefault();
        const selectedOrder = filteredData[selectedOrderIndex];
        handleRowClick(selectedOrder); // Open modal for selected row
      } else if (normalizedKey === "escape") {
        e.preventDefault();
        setIsModalOpen(false);
      } else if (e.shiftKey && normalizedKey === "e") {
        e.preventDefault();
        setIsModalOpen(false);
      }
    },
    [selectedOrderIndex, filteredData, isModalOpen, EKey]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const [eKeyPressed, setEKeyPressed] = useState(
    localStorage.getItem("eKeyPressed")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setEKeyPressed(localStorage.getItem("eKeyPressed"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (eKeyPressed !== "true") {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown, eKeyPressed]);


  const handleFilterChange = (newValue) => {
    setPaymentType(newValue);
    setPagination((prev) => ({ ...prev, current: 1 })); // Reset to first page
    fetchPosCreditData(searchTerm, newValue, 1, pagination.pageSize);
  };

  const handlePaymentTypeChange = (event) => {
    console.log(event)
    const paymentType = event;
    setSelectedPaymentType(paymentType);
    GetAllCustomers("", paymentType)
  };

  const GetAllCustomers = async (text, type = selectedPaymentType) => {
    const payload = {
      offset: (pagination.current - 1) * pagination.pageSize,
      limit: pagination.pageSize,
      store_id: company_id,
      search: text,
      type: type || "", // fallback to empty string
    };

    try {
      const res1 = await axiosInstance.post(URLS.GET_CUSTOMERS, payload);
      if (res1?.data?.result?.status_code === 200) {
        console.log(res1)
        setAllCustomersData(res1?.result?.customer_list);
      } else {
        setAllCustomersData([]);
      }
    } catch (error) {
      console.error("Error fetching Credit History data:", error);
    } finally {
    }
  };


  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isCreditAmountZero={isCreditAmountZero}
        title={t("Customer Credit Details")}
      >
        <CustomerForm
          onSubmit={handleSubmit}
          orderDetails={selectedOrderDetails}
        />
      </Modal>
      {loading ? (
        <div className="px-5">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="flex">
          <div className="flex-grow transition-all duration-300 w-full">
            <div className="bg-[#EEEEEE]">
              <div className="flex flex-row bg-[#EEEEEE] items-center px-4 gap-6">

                {/* Search Bar section */}
                <div className={`${isRtl ? "ms-20" : "ms-12"} bg-[#EEEEEE] flex items-center gap-6`}>
                  <div className="flex-grow min-w-[250px] mt-2">
                    <OrderSearchBar
                      fetchPosCreditData={selectedButton === "allCustomers" ? fetchAllCustomersData : fetchPosCreditData}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      setPagination={setPagination}
                      isAllCustomers={selectedButton === "allCustomers"} // 👈 add this
                    />
                  </div>

                  {/* Dropdown filter only shown for credit customers */}
                  
                </div>
                <div className="w-[75%]">
                  {/* Navigation Tabs */}
                  <div className="flex justify-between items-center mt-2">

                    {/* Left side buttons */}
                    <div className="flex items-center  gap-2">
                      <AllCustomersButton
                        enabled={selectedButton === "allCustomers"}
                        onClick={() => setSelectedButton("allCustomers")}
                        showButtons={false}
                      />

                      <CreditCustomersButton
                        enabled={selectedButton === "creditCustomers"}
                        onClick={() => setSelectedButton("creditCustomers")}
                        showButtons={false}
                      />
                    </div>

                    {selectedButton === "creditCustomers" && (
                    <div className={`${isRtl ? "" : "ms-8"} w-40 min-w-[150px]`}>
                      <Select
                        value={selectedButton === "creditCustomers" ? paymentType : selectedPaymentType}
                        onChange={selectedButton === "creditCustomers" ? handleFilterChange : handlePaymentTypeChange}
                        className="custom-select-height rounded-[6px] text-xl font-bold"
                        popupClassName="payment-type-dropdown"
                        style={{ width: "100%" }}
                        options={[
                          { value: "", label: t("All") },
                          { value: "paid", label: t("Paid") },
                          { value: "unpaid", label: t("Unpaid") },
                        ]}
                      />
                    </div>
                  )}

                    {/* Right side button */}
               {selectedButton === "allCustomers" && (     <button
                      className="w-44  bg-[#1b4597] mt-4 h-12 text-white text-md font-semibold rounded-lg flex items-center justify-center gap-2"
                      onClick={() => setOpenAddCustomerModal(true)}
                    >
                      <span>{t("Add Customer")}</span>
                    </button>
               )}
                  </div>

                </div>

              </div>
            </div>


            {/* --- VIEW 1: ALL CUSTOMERS TAB --- */}

            {
              openAddCustomerModal && <AddCustomerModal
                onClose={() => {
                  setEditData(null);
                  setOpenAddCustomerModal(false)
                }}
                confirm={(data) => { CreateCustomer(data) }}
                showSkipButton={true}
                editData={editData ? editData : null}
                onUpdate={(data) => { UpdateCustomer(data) }}
                loading={loading} />
            }
            {selectedButton === "allCustomers" && (
              allCustomersData.length === 0 ? (
                <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                  <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                    {t("Data not found")}
                  </p>
                </div>
              ) : (
                <div className="flex flex-col justify-center mx-20 mt-7 mb-4 pb-2 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                  <AllCustomerTableComponent
                    columns={AllCustomerColumns}
                    data={allCustomersData}
                    pagination={{
                      current: pagination.current,
                      pageSize: pagination.pageSize,
                      onChange: handleTablePageChange,
                    }}
                    isLoadingData={loading}
                    selectedRowIndex={selectedOrderIndex}
                    onRowClick={handleRowClick}
                  />
                </div>
              )
            )}

            {/* --- VIEW 2: CREDIT CUSTOMERS TAB --- */}
            {selectedButton === "creditCustomers" && (
              filteredData.length === 0 ? (
                <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                  <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                    {t("Data not found")}
                  </p>
                </div>
              ) : (
                <div className="flex flex-col justify-center mx-20 mt-7 mb-4 pb-2 text-sm bg-white text-left rounded-[15px] overflow-hidden">
                  <CreditTableComponent
                    columns={columns}
                    data={filteredData}
                    pagination={{
                      current: pagination.current,
                      pageSize: pagination.pageSize,
                      onChange: handleTablePageChange,
                    }}
                    isLoadingData={loading}
                    onRowClick={handleRowClick}
                    selectedRowIndex={selectedOrderIndex}
                  />
                </div>
              )
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Credit_Table;

